import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { AppState } from 'src/app/reducers'
import { Store } from '@ngrx/store'
import { getStreams, getLoading } from '../../../selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByStreams,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-streams',
    templateUrl: './aggregated-amounts-streams.component.html',
    styleUrls: ['./aggregated-amounts-streams.component.scss'],
    standalone: false
})
export class AggregatedAmountsStreamsComponent implements OnInit {
  streams$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.streams$ = this.store.select(getStreams)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByStreams)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
